const ModeActions = require("../actions/ModeActions.js");
const Store = require("../store.js");

const ModeActionCreators = {
    SwitchTo(mode) {
        Store.dispatch({
            type: ModeActions.Switch,
            Mode: mode
        });
    }
};

module.exports = ModeActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/ModeActionCreators.js